import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import Home from '@/views/Home.vue';
import UserLogin from "@/views/auth/UserLogin.vue";
import Meetings from "@/views/meeting/Meetings.vue";
import MeetingDetails from "@/views/meeting/MeetingDetails.vue";
import PricingPlans from "@/views/pricing-plan/PricingPlans.vue";
import ForgotPassword from "@/views/auth/ForgotPassword.vue";
import ResetPassword from "@/views/auth/ResetPassword.vue";
import SignUp from "@/views/auth/SignUp.vue";


import authGuard from "@/router/authNavigationGuard";
import redirectIfLoggedInGuard from "@/router/redirectIfLoggedInGuard";
import TestComponent from "@/views/test/TestComponent.vue";
import CustomerList from "@/views/customer/CustomerList.vue";
import CreateNewCustomer from "@/views/customer/CreateNewCustomer.vue";
import CustomerDetails from "@/views/customer/details/CustomerDetails.vue";
import SaleAccounts from "@/views/sale-account/SaleAccounts.vue";
import CustomerDetailsSubscription from "@/views/customer/details/CustomerDetailsSubscription.vue";
import CustomerDetailsOverview from "@/views/customer/details/CustomerDetailsOverview.vue";
import CustomerDetailsPaymentHistory from "@/views/customer/details/CustomerDetailsPaymentHistory.vue";
import AdminAccounts from "@/views/admin-accounts/AdminAccounts.vue";
import SubscriptionPlans from "@/views/subscription-plans/SubscriptionPlans.vue";
import NewSubscriptionPlan from "@/views/subscription-plans/NewSubscriptionPlan.vue";
import EditSubscriptionPlan from "@/views/subscription-plans/EditSubscriptionPlan.vue";
import EditCustomer from "@/views/customer/EditCustomer.vue";
import ContactList from "@/views/contact/ContactList.vue";
import TestTypeahead from "@/views/test/TestTypeahead.vue";
import NewMeeting from "@/views/meeting/NewMeeting.vue";
import EditMeeting from "@/views/meeting/EditMeeting.vue";
import ManageAccount from "@/views/account/ManageAccount.vue";
import JoinMeeting from "@/views/meeting/JoinMeeting.vue";
import TestLoadingModal from "@/views/test/TestLoadingModal.vue";
import TestValidateEmail from "@/views/test/TestValidateEmail.vue";
import TestNativeValidate from "@/views/test/TestNativeValidate.vue";
import JoinMeetingForm from "@/views/meeting/JoinMeetingForm.vue";
import NotFound from "@/views/NotFound.vue";
import CustomerUserAccounts from "@/views/customer/CustomerUserAccounts.vue";
import TestCKEditor from "@/views/test/TestCKEditor.vue";
import EmailTemplates from "@/views/EmailTemplates.vue";
import AppNames from "@/views/app-names/AppNames.vue";
import Dashboard from "@/views/Dashboard.vue";
import CustomerMeetings from "@/views/customer/details/CustomerMeetings.vue";
import MeetingCount from "@/views/reports/MeetingCount.vue";
import MeetingCount2 from "@/views/reports/MeetingCount2.vue";
import MeetingCountTotal from "@/views/reports/MeetingCountTotal.vue";
import MeetingDetailReport from "@/views/reports/MeetingDetailReport.vue";
import CalendarList from "@/views/calendar/CalendarList.vue";
import NewCalendar from "@/views/calendar/NewCalendar.vue";
import LocationList from "@/views/locations/LocationList.vue";
import EditCalendar from "@/views/calendar/EditCalendar.vue";
import PasswordPolicy from "@/views/admin-settings/PasswordPolicy.vue";
import ChangePassword from "@/views/auth/ChangePassword.vue";
import CustomerAdminAccounts from "@/views/customer-admin-accounts/CustomerAdminAccounts.vue";
import SystemLogs from "@/views/system-logs/SystemLogs.vue";
import IpPolicy from "@/views/admin-settings/IpPolicy.vue";
import MonitorMeeting from "@/views/monitor/MonitorMeeting.vue";
import BackupPolicy from "@/views/admin-settings/BackupPolicy.vue";
import PortPolicy from "@/views/admin-settings/PortPolicy.vue";
import ManagerConfig from "@/views/admin-settings/ManageConfig.vue";
import EditApiConfig from "@/views/api-config/EditApiConfig.vue";
import NewApiConfig from "@/views/api-config/NewApiConfig.vue";
import Activation from "@/views/auth/Activation.vue";
// import Widget from '@/views/widget/widget.vue';
import GuideAPI from '@/views/guide-api/guide-api.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  { path: '/', name: 'Home', component: Home },
  { path: '/login', name: 'Login', component: UserLogin, beforeEnter: redirectIfLoggedInGuard },
  { path: '/signup', name: 'SignUp', component: SignUp, beforeEnter: redirectIfLoggedInGuard },
  { path: '/activation', name: 'Activation', component: Activation, beforeEnter: redirectIfLoggedInGuard },
  { path: '/change-password', name: 'ChangePassword', component: ChangePassword },
  { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword, beforeEnter: redirectIfLoggedInGuard },
  { path: '/reset-password/:secretKey', name: 'ResetPassword', component: ResetPassword, beforeEnter: redirectIfLoggedInGuard },

  { path: '/dashboard', name: 'Dashboard', component: Dashboard, beforeEnter: authGuard },

  { path: '/reports/meeting-count', name: 'MeetingCount', component: MeetingCount, beforeEnter: authGuard },
  { path: '/reports/meeting-count-d', name: 'MeetingCount2', component: MeetingCount2, beforeEnter: authGuard },
  { path: '/reports/meeting-count-total', name: 'MeetingCountTotal', component: MeetingCountTotal, beforeEnter: authGuard },
  { path: '/reports/meeting-detail-report', name: 'MeetingDetailReport', component: MeetingDetailReport, beforeEnter: authGuard },

  { path: '/meetings/new', name: 'NewMeeting', component: NewMeeting, beforeEnter: authGuard },
  { path: '/meetings/details/:id', name: 'MeetingDetails', component: MeetingDetails, beforeEnter: authGuard },
  { path: '/meetings/edit/:id', name: 'EditMeeting', component: EditMeeting, beforeEnter: authGuard },
  { path: '/meetings', name: 'Meetings', component: Meetings, beforeEnter: authGuard },

  { path: '/join-meeting/:meetingSecretKey', name: 'JoinMeeting', component: JoinMeeting, meta: { mayHaveOrgField: true } },
  { path: '/host/:meetingSecretKey', name: 'HostMeeting', component: JoinMeeting },
  { path: '/join/:meetingSecretKey', name: 'JoinMeetingForm', component: JoinMeetingForm, meta: { mayHaveOrgField: true } },

  { path: '/pricing-plans', name: 'PricingPlans', component: PricingPlans, beforeEnter: authGuard },
  { path: '/customers/create-new', name: 'CreateNewCustomer', component: CreateNewCustomer, beforeEnter: authGuard },
  {
    path: '/customers/details/:id',
    component: CustomerDetails,
    beforeEnter: authGuard,
    children: [
      { path: "", name: "CustomerDetailsOverview", component: CustomerDetailsOverview },
      { path: "subscription", name: "CustomerDetailsSubscription", component: CustomerDetailsSubscription },
      { path: "meetings", name: "CustomerMeetings", component: CustomerMeetings },
      { path: "payment-history", name: "CustomerDetailsPaymentHistory", component: CustomerDetailsPaymentHistory }
    ]
  },
  { path: '/customers/edit/:id', name: 'EditCustomer', component: EditCustomer, beforeEnter: authGuard },
  { path: '/customers', name: 'CustomerList', component: CustomerList, beforeEnter: authGuard },

  { path: '/sale-accounts', name: 'SaleAccounts', component: SaleAccounts, beforeEnter: authGuard },
  { path: '/admin-accounts', name: 'AdminAccounts', component: AdminAccounts, beforeEnter: authGuard },
  { path: '/customer-admin-accounts', name: 'CustomerAdminAccounts', component: CustomerAdminAccounts, beforeEnter: authGuard },
  { path: '/customer-user-accounts', name: 'CustomerUserAccounts', component: CustomerUserAccounts, beforeEnter: authGuard },

  { path: '/subscription-plans/edit/:id', name: "SubscriptionPlanDetails", component: EditSubscriptionPlan, beforeEnter: authGuard },
  { path: '/subscription-plans/new', name: "NewSubscriptionPlan", component: NewSubscriptionPlan, beforeEnter: authGuard },
  { path: '/subscription-plans', name: 'SubscriptionPlans', component: SubscriptionPlans, beforeEnter: authGuard },

  { path: '/contacts', name: 'ContactList', component: ContactList, beforeEnter: authGuard },
  { path: '/email-templates', name: 'EmailTemplates', component: EmailTemplates, beforeEnter: authGuard },

  { path: '/calendar/new', name: 'NewCalendar', component: NewCalendar, beforeEnter: authGuard },
  { path: '/calendar/edit', name: 'EditCalendar', component: EditCalendar, beforeEnter: authGuard },
  { path: '/calendar', name: 'CalendarList', component: CalendarList, beforeEnter: authGuard },

  { path: '/locations', name: 'LocationList', component: LocationList, beforeEnter: authGuard },

  { path: '/app-names', name: 'AppNames', component: AppNames, beforeEnter: authGuard },

  { path: '/admin-settings/password-policy', name: 'PasswordPolicy', component: PasswordPolicy, beforeEnter: authGuard },
  { path: '/admin-settings/ip-policy', name: 'IpPolicy', component: IpPolicy, beforeEnter: authGuard },
  { path: '/system-logs', name: 'SystemLogs', component: SystemLogs, beforeEnter: authGuard },
  { path: '/monitor-meeting/:id', name: 'MonitorMeeting', component: MonitorMeeting, beforeEnter: authGuard },
  { path: '/admin-settings/backup-policy', name: 'BackupPolicy', component: BackupPolicy, beforeEnter: authGuard },
  { path: '/admin-settings/port-policy', name: 'PortPolicy', component: PortPolicy, beforeEnter: authGuard },
  { path: '/admin-settings/manage-config', name: 'ManagerConfig', component: ManagerConfig, beforeEnter: authGuard },

  { path: '/admin-settings/api-config/edit/:id', name: 'EditApiConfig', component: EditApiConfig, beforeEnter: authGuard },
  { path: '/admin-settings/api-config/new', name: 'NewApiConfig', component: NewApiConfig, beforeEnter: authGuard },

  { path: '/test/component', name: 'Test', component: TestComponent },
  { path: '/test/v-select', name: 'TestTypeahead', component: TestTypeahead },
  { path: '/test/loading-modal', name: 'TestLoadingModal', component: TestLoadingModal },
  { path: '/test/validate-email', name: 'TestValidateEmail', component: TestValidateEmail },
  { path: '/test/native-validate', name: 'TestNativeValidate', component: TestNativeValidate },
  { path: '/test/ckeditor', name: 'TestCKEditor', component: TestCKEditor },

  { path: "/account", name: "ManageAccount", component: ManageAccount },
  // { path: "/widget", name: "widget", component: Widget },
  { path: "/guideapi", name: "GuideAPI", component: GuideAPI },
  // { path: '/place-order/payment', name: 'PlaceOrderPayment', component: PlaceOrderPayment, beforeEnter: authGuard },
  // { path: '/place-order/create-account', name: 'PlaceOrderCreateAccount', component: PlaceOrderCreateAccount },
  // { path: '/place-order/successful', name: 'OrderSuccessful', component: OrderSuccessful, beforeEnter: authGuard }
  { path: '*', name: "404", component: NotFound }
];

const router = new VueRouter({
  routes,
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
